export default __webpack_public_path__ + "static/media/our-services-home-care-care-in-your-home-01.634e7ca1.jpg";